import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'list-intakes.component',
  props: {
    intakes: null,
    id: null,
    labelName: null
  },
  emits: ["show-intakes"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (event: "show-intakes", id: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  intakes: string[];
  id: string;
  labelName?: string;
}

const showAllIntakes = ref(false);





const showIntakes = () => {
  emit("show-intakes", props.id);
};

const displayedIntakes = computed(() => {
  if (showAllIntakes.value) {
    return props.intakes;
  }
  return props.intakes.slice(0, 5).map((intake) => intake);
});

// const emit = defineEmit();

return { __sfc: true,showAllIntakes, props, emit, showIntakes, displayedIntakes }
}

})